import { Modal } from "antd";
import { Alert } from "components/elements";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { generateRandomString } from "utils/helper";
import { REQUEST_APPROVE_TAB } from "../schemas/RequestApproveTab";
import * as services from "../service/pendingApprovalApi";
import {
    setIsLoading,
    setPendindExpenseList,
    setPendingChangeShiftList,
    setPendingCollectTimeList,
    setPendingDocumentList,
    setPendingEndorseTimeList,
    setPendingLeaveList,
    setPendingMovement,
    setPendingOffsiteWorkList,
    setPendingOvertimeList,
    setPendingRedeemTimeList
} from "../slices/requestApprovalSlice";
// * not use
function usePending() {
    const dispatch = useDispatch();
    const { i18n, t } = useTranslation();
    const [lang, setLang] = useState("en");
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const currentApprover = useSelector((state) => state.company.currentEmployee);
    const [pendingTab, setPendingTab] = useState(REQUEST_APPROVE_TAB.LEAVE);
    const [pagination, setPagination] = useState({ page: 0, size: 10 });
    const { isLoading } = useSelector((state) => state.requestApproval)
    const [sorter, setSorter] = useState([]);
    const [leaveGroupOptions, setLeaveGroupOptions] = useState([]);
    const currentEmployee = useSelector((state) => state.company.currentEmployee);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [offSiteOptions, setOffSiteOptions] = useState([]);
    const [companyRegulationOptions, setCompanyRegulationOptions] = useState([]);
    const [penaltiesOptions, setPenaltiesOptions] = useState([]);
    const { pendingDocumentList, pendingChangeShiftList } = useSelector((state) => state.requestApproval)
    const [pageType, setPageType] = useState();


    function toParams(params) {
        const { pagination = {}, sortBy = [] } = params;
        const modifiedParams = {
            ...params,
            page: pagination.page || 0,
            size: pagination.pageSize || 10,
            sortBy: sortBy
                .filter((s) => s.order !== undefined)
                .map((s) => ({
                    direction: s.order === "descend" ? "desc" : "asc",
                    property: s.field,
                })),
        };
        return modifiedParams;
    }

    const getPendingLeaveLists = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getPendingLeaveRequest({

                    ...params,
                    ...pagination,
                    companyId: currentCompany,
                    approverId: currentApprover,
                    pagingType: params?.pagingType ? params?.pagingType : "pending"
                });
                dispatch(setPendingLeaveList(response.data?.content || []))
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, currentApprover]
    );


    const getPendingOffsiteWorkLists = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getPendingOffsiteWorkRequest({

                    ...params,
                    ...pagination,
                    companyId: currentCompany,
                    approverId: currentApprover,
                    pagingType: params?.pagingType ? params?.pagingType : "pending"

                });

                dispatch(setPendingOffsiteWorkList(response.data?.content || []))
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, currentApprover]
    );

    const getPendingCollectTimeLists = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getPendingCollectTimeRequest({

                    ...params,
                    ...pagination,
                    companyId: currentCompany,
                    approverId: currentApprover,
                    pagingType: params?.pagingType ? params?.pagingType : "pending"

                });
                dispatch(setPendingCollectTimeList(response.data?.content || []))
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, currentApprover]
    );

    const getPendingOvertimeLists = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getPendingOvertimeRequest({

                    ...params,
                    ...pagination,
                    companyId: currentCompany,
                    approverId: currentApprover,
                    pagingType: params?.pagingType ? params?.pagingType : "pending"

                });
                dispatch(setPendingOvertimeList(response?.data?.content || []))
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, currentApprover]
    );

    const getPendingEndorseTimeLists = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getPendingEndorseTimeRequest({

                    ...params,
                    ...pagination,
                    companyId: currentCompany,
                    approverId: currentApprover,
                    pagingType: params?.pagingType ? params?.pagingType : "pending"

                });
                dispatch(setPendingEndorseTimeList(response?.data?.content || []))
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, currentApprover]
    );

    const getPendingRedeemTimeLists = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getPendingRedeemTimeRequest({
                    ...params,
                    ...pagination,
                    companyId: currentCompany,
                    approverId: currentApprover,
                    pagingType: params?.pagingType ? params?.pagingType : "pending"

                });
                dispatch(setPendingRedeemTimeList(response?.data?.content || []))
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, currentApprover]
    );

    const getPendingExpense = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.pendingApproveExpense({

                    ...params,
                    ...pagination,
                    companyId: currentCompany,
                    approverId: currentApprover,
                    pagingType: params?.pagingType ? params?.pagingType : "pending"

                });

                dispatch(setPendindExpenseList(response?.data?.pendingExpense || []))
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, currentApprover]
    );

    const getPendingMovement = useCallback(async () => {
        try {
            dispatch(setIsLoading(true))
            const response = await services.getPendingMovement({
                ...pagination,
                companyId: currentCompany,
                approverId: currentApprover,
                employeeId: currentApprover,
                pagingType: "pending"
            })
            dispatch(setPendingMovement(response?.data?.content))
            // // Alert({ message: "success" })
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany,
        currentApprover, isLoading])

    const getPendingChangeShiftLists = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getPendingChangeShiftRequest({

                    ...params,
                    ...pagination,
                    companyId: currentCompany,
                    approverId: currentApprover,
                    pagingType: "pending"

                });

                dispatch(setPendingChangeShiftList(response.data?.pendingChangeShiftList || []))
                setPagination({
                    page: params.page + 1,
                    size: params.size,
                    range: [
                        params.page * params.size + 1,
                        Math.min((params.page + 1) * params.size, response.data?.totalItems),
                    ],
                    total: response.data?.totalItems,
                });
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentApprover, dispatch]
    );

    const getPendingDocumentLists = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getPendingDocumentRequest({
                    ...params,
                    ...pagination,
                    companyId: currentCompany,
                    approverId: currentApprover,
                    pagingType: "pending"

                });
                dispatch(setPendingDocumentList(response?.data?.content || []))

            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentApprover, dispatch]
    );



    const onHistory = useCallback(async () => {
        try {
            dispatch(setIsLoading(true));
            switch (pendingTab) {
                case REQUEST_APPROVE_TAB.LEAVE:
                    await getPendingLeaveLists({
                        ...pagination,
                        pagingType: "history"
                    })

                case REQUEST_APPROVE_TAB.OFFSITEWORK:
                    await getPendingOffsiteWorkLists({
                        ...pagination,
                        pagingType: "history"
                    })

                case REQUEST_APPROVE_TAB.REDEEMTIME:
                    await getPendingRedeemTimeLists({
                        ...pagination,
                        pagingType: "history"
                    })

                case REQUEST_APPROVE_TAB.ENDORSETIME:
                    await getPendingEndorseTimeLists({
                        ...pagination,
                        pagingType: "history"
                    })

                case REQUEST_APPROVE_TAB.OVERTIME:
                    await getPendingOvertimeLists({
                        ...pagination,
                        pagingType: "history"
                    })

                case REQUEST_APPROVE_TAB.COLLECTTIME:
                    await getPendingCollectTimeLists({
                        ...pagination,
                        pagingType: "history"
                    })

                case REQUEST_APPROVE_TAB.EXPENSE:
                    await getPendingExpense({
                        ...pagination,
                        pagingType: "history"
                    })

                case REQUEST_APPROVE_TAB.REQUESTFORM:
                    await getPendingDocumentLists({
                        ...pagination,
                        pagingType: "history"
                    })

                case REQUEST_APPROVE_TAB.CHANGESHIFT:
                    await getPendingChangeShiftLists({
                        ...pagination,
                        pagingType: "history"
                    })

                case REQUEST_APPROVE_TAB.MOVEMENT:
                    await getPendingMovement({
                        ...pagination,
                        pagingType: "history"
                    })

                default:
                    break;
            }

        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [pagination, currentApprover, currentCompany, pendingTab])

    const handleQueryPending = useCallback(() => {
        switch (pendingTab) {
            case "PendingApprovalLeaveTable":
                getPendingLeaveLists({
                    ...pagination,
                })
                break;
            case "PendingApprovalOffsiteWorkTable":
                getPendingOffsiteWorkLists({
                    ...pagination,
                })
                break;
            case "PendingApprovalRedeemTimeTable":
                getPendingRedeemTimeLists({
                    ...pagination,
                })
                break;

            case "PendingApprovalEndorseTimeTable":
                getPendingEndorseTimeLists({
                    ...pagination,
                })
                break;
            case "PendingApprovalOvertimeTable":
                getPendingOvertimeLists({
                    ...pagination,
                })
                break;
            case "PendingApprovalCollectTimeTable":
                getPendingCollectTimeLists({
                    ...pagination,
                })
                break;
            case "PendingApprovalExpenseTable":
                getPendingExpense({
                    ...pagination,
                })
                break;
            case "RequestForm":
                getPendingDocumentLists({
                    ...pagination,
                })
                break;
            case "ChangeShift":
                getPendingChangeShiftLists({
                    ...pagination,
                })
                break;
            case "Movement":
                getPendingMovement({
                    ...pagination
                })
                break;

            default:
                break;
        }
    }, [pendingTab, currentCompany, currentApprover, pagination])

    const onCloseHistoryModal = useCallback(() => {
        setPageType("pending")
    }, [handleQueryPending])

    const onHistoryClick = useCallback(() => {
        setPageType("history")
    })





    const approveLeaveRequest = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true));
            await services.approveLeaveRequest(values)
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentApprover, isLoading])

    const approveOffsiteWorkRequest = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true));
            await services.approveOffsiteWorkRequest(values)

            getPendingOffsiteWorkLists({
                ...pagination
            })
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentApprover, isLoading])

    const approveRedeemTimeRequest = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true));

            await services.approveRedeemTimeRequest(values)
            getPendingRedeemTimeLists({
                ...pagination
            })
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentApprover, isLoading])

    const approveEndorseTimeRequest = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true));
            await services.approveEndorseTimeRequest(values)

            getPendingEndorseTimeLists({
                ...pagination
            })
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentApprover, isLoading, pagination])

    const approveOvertimeRequest = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true));
            await services.approveOvertimeRequest(values)

            getPendingOvertimeLists({
                ...pagination
            })

        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentApprover, isLoading, pagination])

    const approveCollectTimeRequest = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true));
            await services.approveCollectTimeRequest(values)

            getPendingCollectTimeLists({
                ...pagination
            })
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentApprover, isLoading, pagination])

    const approveExpenseRequest = useCallback(async (values) => {
        try {
            dispatch(setIsLoading(true));
            await services.approveExpenseRequest(values)

            getPendingExpense({
                ...pagination
            })
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentApprover, isLoading])

    const approveMovement = useCallback(async (record) => {
        try {
            dispatch(setIsLoading(true))
            const requestBody = {
                companyId: currentCompany,
                approverId: currentApprover,
                employeeId: currentApprover,
                actionId: currentApprover,
                requestIds: record?.requestId,
                sendingType: "APPROVED"
            }
            await services.approveMovement(requestBody)
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentApprover, isLoading])

    const approveDocumentlist = useCallback(async (record) => {
        try {
            dispatch(setIsLoading(true))
            const requestBody = {
                companyId: currentCompany,
                approverId: currentApprover,
                sendingType: record.sendingType,
                requestIds: record.id
            }
            await services.approveDocumentRequest(requestBody)
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentApprover, isLoading])

    const approveChangeShift = useCallback(async (record) => {
        try {
            dispatch(setIsLoading(true))
            const requestBody = {
                companyId: currentCompany,
                approverId: currentApprover,
                sendingType: record.sendingType,
                requestIds: record.requestId
            }
            await services.approveChangeShiftRequest(requestBody)
        } catch (error) {
            Alert({ type: "error", resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentApprover, isLoading])

    const handleApprove = useCallback((values) => {
        const params = {
            companyId: currentCompany,
            approverId: currentApprover,
            sendingType: values?.sendingType,
            requestIds: values?.id,
            attachFiles: []
        };
        if (values?.table) {
            switch (values?.table) {
                case "PendingApprovalLeaveTable":
                    approveLeaveRequest(params)
                    break;

                case "PendingApprovalOffsiteWorkTable":
                    approveOffsiteWorkRequest(params)
                    break;

                case "PendingApprovalRedeemTimeTable":
                    approveRedeemTimeRequest(params)
                    break;

                case "PendingApprovalEndorseTimeTable":
                    approveEndorseTimeRequest(params)
                    break;

                case "PendingApprovalOvertimeTable":
                    approveOvertimeRequest(params)
                    break;

                case "PendingApprovalCollectTimeTable":
                    approveCollectTimeRequest(params)
                    break;
                case "PendingApprovalExpenseTable":
                    approveExpenseRequest(params)
                    break;
                case "RequestForm":
                    approveDocumentlist(params)
                    break;
                case "ChangeShift":
                    approveChangeShift(params)
                    break;
                case "Movement":
                    approveMovement(params)
                    break;
                default:
                    break;
            }
        } else {

            switch (pendingTab) {
                case "PendingApprovalLeaveTable":
                    approveLeaveRequest(params)
                    break;

                case "PendingApprovalOffsiteWorkTable":
                    approveOffsiteWorkRequest(params)
                    break;

                case "PendingApprovalRedeemTimeTable":
                    approveRedeemTimeRequest(params)
                    break;

                case "PendingApprovalEndorseTimeTable":
                    approveEndorseTimeRequest(params)
                    break;

                case "PendingApprovalOvertimeTable":
                    approveOvertimeRequest(params)
                    break;

                case "PendingApprovalCollectTimeTable":
                    approveCollectTimeRequest(params)
                    break;
                case "PendingApprovalExpenseTable":
                    approveExpenseRequest(params)
                    break;
                case "RequestForm":
                    approveDocumentlist(params)
                    break;
                case "ChangeShift":
                    approveChangeShift(params)
                    break;
                case "Movement":
                    approveMovement(params)
                    break;
                default:
                    break;
            }
        }
    }, [currentCompany, pendingTab, sorter, isLoading, currentApprover]);

    const modifiedLeaveGroupOptions = useMemo(() => {
        return leaveGroupOptions.map((opt) => ({

            ...opt,
            label: lang === "en" ? opt.leaveTypeNameEn : opt.leaveTypeName,
            value: opt.leaveId,
        }));
    }, [lang, leaveGroupOptions]);

    const getLeaveGroupOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                };
                const response = await services.getLeaveGroupIsLeaveApproval(values);
                setLeaveGroupOptions(response.data);
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);

    useEffect(() => {
        getLeaveGroupOptions();
    }, [getLeaveGroupOptions]);

    const modifiedEmployeeOptions = useMemo(() => {
        return employeeOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.fullNameEn : opt.fullName,
            value: opt.id,
        }));
    }, [lang, employeeOptions]);

    const getEmployeeOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                };
                const response = await services.getDropDown(values);
                setEmployeeOptions(response.data);
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);

    useEffect(() => {
        getEmployeeOptions();
    }, [getEmployeeOptions]);

    const modifiedOffSiteOptions = useMemo(() => {
        return offSiteOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.nameEn : opt.name,
            value: opt.id,
        }));
    }, [lang, offSiteOptions]);

    const getOffSiteOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                };
                const response = await services.getLeaveGroupIsOffSite(
                    values
                );
                setOffSiteOptions(response.data);
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);

    useEffect(() => {
        getOffSiteOptions();
    }, [getOffSiteOptions]);

    const modifiedCompanyRegulationOptions = useMemo(() => {
        return companyRegulationOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.nameEn : opt.name,
            value: opt.id,
        }));
    }, [lang, companyRegulationOptions]);

    const getCompanyRegulationOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                };
                const response = await services.getCompanyRegulationOptions(
                    values
                );
                setCompanyRegulationOptions(response.data);
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);
    useEffect(() => {
        getCompanyRegulationOptions();
    }, [getCompanyRegulationOptions]);

    const modifiedPenaltiesOptions = useMemo(() => {
        return penaltiesOptions.map((opt) => ({
            ...opt,
            label: lang === "en" ? opt.nameEn : opt.name,
            value: opt.id,
        }));
    }, [lang, penaltiesOptions]);

    const getPenaltiesOptions = useCallback(async () => {
        if (typeof currentCompany !== "object") {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                };
                const response = await services.getPenaltiesOptions(values);
                setPenaltiesOptions(response.data);
            } catch (error) {
                Alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        }
    }, [currentCompany, dispatch]);

    useEffect(() => {
        getPenaltiesOptions();
    }, [getPenaltiesOptions]);

    const onApprove = useCallback(
        (record) => {
            Modal.confirm({
                title: "Confirmation",
                content: (
                    <>
                        <p>Are you sure confirm to APPROVED the request ?</p>
                    </>
                ),
                onOk() {
                    handleApprove({ ...record, sendingType: "APPROVED" });
                },
                okText: "CONFIRM",
                cancelText: "CANCEL",
            });
        },
        [pendingTab]
    );

    const onReject = useCallback(
        (record) => {
            Modal.confirm({
                title: "Confirmation",
                content: (
                    <>
                        <p>Are you sure confirm to REJECT the request ?</p>
                    </>
                ),
                onOk() {
                    handleApprove({ ...record, sendingType: "REJECT" });
                },
                okText: "CONFIRM",
                cancelText: "CANCEL",
            });
        },
        []
    );

    const onCancel = useCallback(
        (record) => {
            Modal.confirm({
                title: "Confirmation",
                content: (
                    <>
                        <p>Are you sure confirm to CANCEL the request ?</p>
                    </>
                ),
                onOk() {
                    handleApprove({ ...record, sendingType: "CANCELLED" });
                },
                okText: "CONFIRM",
                cancelText: "CANCEL",
            });
        },
        []
    );

    const onReturn = useCallback(
        (record) => {
            Modal.confirm({
                title: "Confirmation",
                content: (
                    <>
                        <p>Are you sure confirm to RETURN the request ?</p>
                    </>
                ),
                onOk() {
                    handleApprove({ ...record, sendingType: "RETURN" });
                },
                okText: "CONFIRM",
                cancelText: "CANCEL",
            });
        },
        [pendingTab, currentCompany, currentApprover]
    );

    const onSearch = useCallback((values) => {

        values.startDate = values?.startDate?.format?.("YYYY-MM-DD")
        values.endDate = values?.endDate?.format?.("YYYY-MM-DD")
        values.endorseDate = values?.endorseDate?.format?.("YYYY-MM-DD")
        values.collectDate = values?.collectDate?.format?.("YYYY-MM-DD")
        values.approveDate = values?.approveDate?.format?.("YYYY-MM-DD")
        switch (pendingTab) {
            case "PendingApprovalLeaveTable":
                getPendingLeaveLists({
                    ...pagination,
                    ...values,
                })
                break;
            case "PendingApprovalOffsiteWorkTable":
                getPendingOffsiteWorkLists({
                    ...pagination, ...values,
                })
                break;
            case "PendingApprovalRedeemTimeTable":
                getPendingRedeemTimeLists({
                    ...pagination, ...values,
                })
                break;

            case "PendingApprovalEndorseTimeTable":
                getPendingEndorseTimeLists({
                    ...pagination, ...values,
                })
                break;
            case "PendingApprovalOvertimeTable":
                getPendingOvertimeLists({
                    ...pagination, ...values,
                })
                break;
            case "PendingApprovalCollectTimeTable":
                getPendingCollectTimeLists({
                    ...pagination, ...values,
                })
                break;
            case "PendingApprovalExpenseTable":
                getPendingExpense({
                    ...pagination, ...values,
                })
                break;
            case "RequestForm":
                getPendingDocumentLists({
                    ...pagination, ...values
                })
                break;
            case "ChangeShift":
                getPendingChangeShiftLists({
                    ...pagination, ...values
                })
                break;
            case "Movement":
                getPendingMovement({
                    ...pagination, ...values,
                })
                break;

            case "PendingApprovalHistoryTable":
                onHistory()
                break;

            default:
                break;
        }
    }, [pendingTab, currentCompany, currentApprover, pagination])


    useEffect(() => {
        setLang(i18n.language);
    }, [i18n.language, setLang]);




    // useEffect(() => {
    //     if (pageType && pageType === 'pending') {
    //         handleQueryPending()
    //     } else {
    //         onHistory()
    //     }
    // }, [pageType, pendingTab])

    // useEffect(() => {
    //     if (currentCompany) {
    //         pendingTable()
    //     }
    // }, [handleQueryPending, currentCompany])

    return {
        modifiedOffSiteOptions,
        modifiedEmployeeOptions,
        modifiedLeaveGroupOptions,
        modifiedCompanyRegulationOptions,
        modifiedPenaltiesOptions,
        leaveGroupOptions,
        handleQueryPending,
        // pendingTab,
        // onPendingTabChange,
        // pendingTable,
        onApprove,
        onReject,
        onCancel,
        onReturn,
        onSearch,
        onCloseHistoryModal,
        onHistory
    }

}
export default usePending